import { commonService } from '../../_services'
const noticationSettingService = commonService('api/v1/notification-settings')

const initialState = {
    all: { items: [] },
    loading: false,
}

const deepCloneInitial = () => {
    return JSON.parse(JSON.stringify(initialState))
}

/* tslint:disable:variable-name */
export const notification_settings = {
    namespaced: true,
    state: deepCloneInitial,
    actions: {
        async getAll(context: any): Promise<void> {
            context.commit('GET_ALL_REQUEST')

            return noticationSettingService.getAll().then((resp) => {
                context.commit('GET_ALL_SUCCESS', resp.data)
            }).catch(errorMsg => {
                context.commit('GET_ALL_FAILURE')
                context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
            })
        },
        async addOne(context: any, data: any): Promise<void> {
            context.commit('ADD_REQUEST')

            return noticationSettingService.addOne(data).then((resp) => {
                // Fetch just added data
                noticationSettingService.getOne(resp.data._id).then(singleData => {
                    context.commit('ADD_ITEM_SUCCESS', singleData.data)
                })
                return Promise.resolve(resp.data)
            }).catch(errorMsg => {
                context.commit('REQUEST_ERROR')
                context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
                return Promise.reject(errorMsg)
            })
        },
        async updateOne(context: any, data: any): Promise<void> {
            context.commit('UPDATE_REQUEST')

            return noticationSettingService.updateOne(data).then((resp) => {
                context.commit('UPDATE_ITEM_SUCCESS', data)
                return Promise.resolve(resp.data)
            }).catch(errorMsg => {
                context.commit('REQUEST_ERROR')
                context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
                return Promise.reject(errorMsg)
            })
        },
        async deleteOne(context: any, item: any): Promise<void> {
            context.commit('DELETE_REQUEST')
            noticationSettingService.deleteOne(item._id).then((resp) => {
                context.commit('DELETE_ITEM_SUCCESS', item)
                return Promise.resolve(resp.data)
            }).catch(errorMsg => {
                context.commit('REQUEST_ERROR')
                context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
            })
        }
    },
    mutations: {
        GET_ALL_REQUEST(state: any) {
            state.loading = true
        },
        GET_ALL_SUCCESS(state: any, allItems: any[]) {
            state.all = { items: allItems.map(item => item) }
            state.loading = false
        },
        GET_ALL_FAILURE(state: any) {
            state.all = { items: [] }
            state.loading = false
        },
        GET_REQUEST(state: any) {
            state.loading = true
        },
        ADD_REQUEST(state: any) {
            state.loading = true
        },
        UPDATE_REQUEST(state: any) {
            state.loading = true
        },
        DELETE_REQUEST(state: any) {
            state.loading = true
        },
        ADD_ITEM_SUCCESS(state: any, item: any) {
            state.all.items.push(item)
            state.loading = false
        },
        UPDATE_ITEM_SUCCESS(state: any, item: any) {
            state.all.items = state.all.items.map(tmp => {
                return tmp._id === item._id ? item : tmp
            })

            state.loading = false
        },
        DELETE_ITEM_SUCCESS(state: any, item: any) {
            const index = state.all.items.indexOf(item)
            state.all.items.splice(index, 1)
            state.loading = false
        },
        REQUEST_ERROR(state: any) {
            state.loading = false
        },
        RESET_STATE(state: any) {
            Object.keys(initialState).forEach(key => {
                state[key] = initialState[key]
            })
        },
    },
    getters: {
        canEdit: state => () => {
            return noticationSettingService.canEdit()
        },
        canDelete: state => () => {
            return noticationSettingService.canDelete()
        }
    },
}
